import { z } from 'zod';

// Parse env vars and fail immediately if not set properly
const envSchema = z.object({
  VITE_NODE_ENV: z.enum(['development', 'staging', 'production']),
  VITE_STRIPE_KEY: z.string(),
});

export type EnvSchemaTypes = z.infer<typeof envSchema>;

export const env = envSchema.parse({
  VITE_NODE_ENV: import.meta.env.VITE_NODE_ENV,
  VITE_STRIPE_KEY: import.meta.env.VITE_STRIPE_KEY,
});
